export class SetItem {
  static readonly type = '[Secure] Set Item';
  constructor(public key: string, public value: string) {}
}

export class Logout {
  static readonly type = '[Session] Logout';
}
